const TEST_CONFIG = Object.freeze({
    IspUrl: 'https://jpaas-ks.vlinkcloud.net/',
    tenantKey: '2043933702295261185',
    gameId: '2043933910131412994520041'
})

const PRODUCTION_CONFIG = Object.freeze({
    IspUrl: 'https://paas-sdk.vlinkcloud.cn/',
    tenantKey: '2043984272116813825',
    gameId: '2043984391054692353600139'
})

const CONFIG_BY_ENV = Object.freeze({
    dev: TEST_CONFIG,
    develop: TEST_CONFIG,
    pre: TEST_CONFIG,
    master: PRODUCTION_CONFIG
})

export const CLOUD_GAME_CHANNEL_KEY = '1_4261'

export function getCloudGameConfig (env) {
    const envConfig = CONFIG_BY_ENV[env]
    if (!envConfig) {
        throw new Error(`不支持的云游戏环境: ${env || '未配置'}`)
    }

    return Object.freeze({
        ...envConfig,
        containerId: 'cgameLayer',
        primaryX: '1920',
        primaryY: '1080',
        bitrateRange: Object.freeze({
            lowerLimit: 10000,
            upperLimit: 20000
        }),
        queuePollInterval: 10000,
        startTimeout: 30000
    })
}
